module.exports = __webpack_public_path__ + "static/media/saren.24e352fc.png";